'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _select = require('@alicd/next/lib/select');

var _select2 = _interopRequireDefault(_select);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _moment = require('@alicd/next/lib/moment');

var _moment2 = _interopRequireDefault(_moment);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _radio = require('@alicd/next/lib/radio');

var _radio2 = _interopRequireDefault(_radio);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _calendarMixin = require('../calendar-mixin');

var _calendarMixin2 = _interopRequireDefault(_calendarMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioGroup = _radio2.default.Group;

var BasicSelectTool = function (_Component) {
    (0, _inherits3.default)(BasicSelectTool, _Component);

    function BasicSelectTool(props) {
        (0, _classCallCheck3.default)(this, BasicSelectTool);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BasicSelectTool.__proto__ || (0, _getPrototypeOf2.default)(BasicSelectTool)).call(this, props));

        _this.state = {
            base: props.base,
            mode: props.mode
        };
        return _this;
    }

    (0, _createClass3.default)(BasicSelectTool, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            if ('base' in newProps) {
                this.setState({
                    base: newProps.base
                });
            }

            if ('mode' in newProps) {
                this.setState({
                    mode: newProps.mode
                });
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(key, nextBase) {
            var _state = this.state,
                base = _state.base,
                mode = _state.mode;


            switch (key) {
                case 'year':
                    {
                        base = (0, _moment2.default)(base).year(nextBase);
                        break;
                    }
                case 'month':
                    {
                        base = (0, _moment2.default)(base).month(nextBase);
                        break;
                    }
                case 'mode':
                    {
                        mode = nextBase;
                        break;
                    }
            }

            this.props.onChange({
                base: base,
                mode: mode
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                prefix = _props.prefix,
                type = _props.type,
                locale = _props.locale,
                language = _props.language,
                others = (0, _objectWithoutProperties3.default)(_props, ['prefix', 'type', 'locale', 'language']);
            var _state2 = this.state,
                base = _state2.base,
                mode = _state2.mode;


            var size = type === 'fullscreen' ? 'medium' : 'small';

            // get year
            var yearOptions = this.getLateastYears(base.year()).map(function (year, index) {
                return _react2.default.createElement(
                    'option',
                    { key: index, value: year },
                    year
                );
            });

            // get month
            var monthsLocale = locale.format ? locale.format.shortMonths : this.getMonthsLocale(language);
            var monthOptions = monthsLocale.map(function (month, index) {
                return _react2.default.createElement(
                    'option',
                    { key: index, value: index },
                    month
                );
            });

            // get class
            var basicCls = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, prefix + 'calendar-pick-tool', true), (0, _defineProperty3.default)(_classNames, prefix + 'calendar-basic-pick-tool', true), _classNames));

            return _react2.default.createElement(
                'div',
                { className: basicCls },
                _react2.default.createElement(
                    _select2.default,
                    { prefix: prefix,
                        value: base.year(),
                        size: size,
                        onChange: this.onChange.bind(this, 'year'),
                        container: function container(target) {
                            return target.parentNode;
                        },
                        autoWidth: false },
                    yearOptions
                ),
                _react2.default.createElement(
                    _select2.default,
                    { prefix: prefix,
                        value: base.month(),
                        size: size,
                        onChange: this.onChange.bind(this, 'month'),
                        container: function container(target) {
                            return target.parentNode;
                        },
                        autoWidth: false },
                    monthOptions
                ),
                _react2.default.createElement(
                    RadioGroup,
                    { shape: 'button', size: size, value: mode, onChange: this.onChange.bind(this, 'mode') },
                    _react2.default.createElement(
                        _radio2.default,
                        { value: 'month' },
                        locale.month
                    ),
                    _react2.default.createElement(
                        _radio2.default,
                        { value: 'year' },
                        locale.year
                    )
                )
            );
        }
    }]);
    return BasicSelectTool;
}(_react.Component);

BasicSelectTool.propTypes = {
    onChange: _propTypes2.default.func
};


(0, _calendarMixin2.default)(BasicSelectTool);

exports.default = BasicSelectTool;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-calendar-ex@0.0.4@@alicd/crui-calendar-ex/lib/view/module/basic-pick-tool.js
// module id = 619
// module chunks = 0